import {
    Card,
    CardContent,
    CardHeader,
    Grid,
    MenuItem,
    TextField,
  } from '@material-ui/core';
  import 'date-fns';
  import { green, red } from '@material-ui/core/colors';
  import { makeStyles, ThemeProvider } from '@material-ui/styles';
  import React, { useEffect, useState } from 'react';
  import 'react-confirm-alert/src/react-confirm-alert.css';
  import { useTranslation } from 'react-i18next';
  import 'react-phone-input-2/lib/style.css';
  import Autocomplete from '@material-ui/lab/Autocomplete';
  import ReactFlagsSelect from 'react-flags-select';
  import axios from 'src/utils/axios';
  import {
      getUser
    } from 'src/utils/Common';
  
      const useStyles = makeStyles(theme => ({
          rootTopBar: {
          display: 'flex',
          alignItems: 'center',
          width: '100%',
          paddingTop: 20,
          paddingLeft: 20,
          paddingBottom: 20,
          paddingRight: 20
          },
          fabGreen: {
          position: "fixed",
          bottom: theme.spacing(2),
          right: theme.spacing(2),
          color: theme.palette.common.white,
          backgroundColor: green[500],
          "&:hover": {
              backgroundColor: green[600]
          }
          },
          inputTopBar: {
          marginLeft: theme.spacing(1),
          flex: 1
          },
          iconButtonTopBar: {
          padding: 10
          },
          dividerTopBar: {
          height: 28,
          margin: 4
          },
          cover: {
          height: '140'
          },
          avatarAtanan: {
          backgroundColor: red[500]
          },
          avatar1Atanan: {
          backgroundColor: green[500]
          },
          valueAtanan: {
          fontWeight: theme.typography.fontWeightMedium
          },
          typeAtanan: {
          fontWeight: theme.typography.fontWeightMedium
          },
          searchAtanan: {
          flexGrow: 1,
          height: 42,
          padding: theme.spacing(0, 2),
          display: 'flex',
          alignItems: 'center'
          },
          searchIconAtanan: {
          marginRight: theme.spacing(2),
          color: theme.palette.icon
          },
          searchInputAtanan: {
          flexGrow: 1
          },
          pageStyleAtanan: {
          display: 'flex',
          padding: '2px 4px'
          },
          inputAtanan: {
          marginLeft: theme.spacing(1),
          flex: 1
          },
          iconButtonAtanan: {
          padding: 10
          },
          fieldsAtanan: {
          margin: theme.spacing(-1),
          display: 'flex',
          flexWrap: 'wrap',
          '& > *': {
              flexGrow: 1,
              margin: theme.spacing(1)
          }
          },
          backdrop: {
          zIndex: theme.zIndex.drawer + 1,
          color: '#fff'
          },
          actions: {
          justifyContent: 'flex-end'
          },
      
          cardscontent: {
          minHeight: 500,
          minWidth: 400
          },
          expand: {
          transform: 'rotate(0deg)',
          marginLeft: 'auto',
          transition: theme.transitions.create('transform', {
              duration: theme.transitions.duration.shortest
          })
          },
          expandOpen: {
          transform: 'rotate(180deg)'
          },
          cardsInfoMax: {
          // maxHeight: 230,
          minHeight: 200
          },
          cardsMax: {
          maxHeight: 230,
          minHeight: 230
          },
          cardsAssetMax: {
          maxHeight: 550,
          minHeight: 550
          },
          cardsContentMax: {
          maxHeight: 180,
          minHeight: 180
          },
          cardsMaxF: {
          // maxHeight: 230,
          minHeight: 350
          },
          cardsContentMax: {
          maxHeight: 180,
          minHeight: 150
          },
          cardsContentMaxF: {
          // maxHeight: 180,
          minHeight: 300
          },
      
          cardscontent: {
          minHeight: 350
          },
          cards: {
          minHeight: 500
          // maxHeight: 500,
          },
          root: {
          flexGrow: 1
          },
          paper: {
          padding: theme.spacing(2),
          textAlign: 'center',
          color: theme.palette.text.secondary
          },
          root: {
          flexGrow: 1
          },
          paper: {
          padding: theme.spacing(2),
          textAlign: 'center',
          color: theme.palette.text.secondary
          },
          cardArddress: {
          minHeight: 340,
          maxHeight: 340
          }
      }));
  
  
      function ConsumerAddress({
        consumerAddressData
        ,consumerData
        ,serviceAddressData
        ,setStreetData
        ,setApartmentData 
        ,setAddressData       
        ,setStateData         
        ,setAddressItemData   
        ,setCityData          
        ,setCountryData       
        ,setDistrictData      
        ,setDoorNrData        
        ,setNeighborhoodData  
        ,setPostCodeData      
        ,setRegionData 
        ,setEmailData
        ,setPhoneData
        ,setNameData     
        ,setAddressTypeIdData 
       }){
          const classes = useStyles();
          const { t } = useTranslation('overview');
          const [AddressTypes, setAddressTypes] = useState([]);
          const [RegionData2, setRegionData2] = useState([]);
          const [CityData2, setCityData2] = useState([]);
          const [DistrictData2, setDistrictData2] = useState([]);
          const SessionUser = getUser();
          const locale = localStorage.getItem('i18nextLng');
          const [loading2, setLoading2] = useState(false);
          const [selected, setSelected] = useState(
              SessionUser.TenantCode.toUpperCase()
            );
          const [stateAddress, setStateAddress] = React.useState({
              StateScreen: true,
              RegionScreen: true,
              ApartmentScreen: true,
              DoorNrScreen: true,
              PostCodeScreen: true,
              LongitudeScreen: true,
              LatitudeScreen: true
            });
          const {
              StateScreen,
              RegionScreen,
              ApartmentScreen,
              DoorNrScreen,
              PostCodeScreen,
          } = stateAddress;
          const [Districtfiltered, setDistrictFiltered] = useState(false);
          
  
          const GetRegionRequest = () => {
            setLoading2(true);
            axios
              .get('/GetRegionRequest/')
              .then(response => {
                setRegionData2(response.data);
                if (response.data.length == 1) {
                  GetCityRequest();
                }
                setLoading2(false);
              })
              .catch(error => {
                setLoading2(false);
              });
          };
  
          const GetCity = (event,newInputValue) => {
              setRegionData(newInputValue);
          
              if (RegionData2.includes(newInputValue)) {
                GetCityRequestByRegion(newInputValue);
              } else {
                changeRegionAndCityData2(selected);
              }
          };
  
          const GetCityRequestByRegion = regionName => {
              setLoading2(true);
              axios
                .get('/GetCityRequestByRegion/' + regionName)
                .then(response => {
                  setCityData2(response.data);
                  setLoading2(false);
                })
                .catch(error => {
                  setLoading2(false);
                });
          };
  
          const GetDistrictRequest = (event, newInputValue) => {
              setCityData(newInputValue);  
  
              if (CityData2.includes(newInputValue) && !Districtfiltered) {
                GetDistrictData(newInputValue);
              }
            
          };
  
          function changeRegionAndCityData2(cityCode) {
              axios
                .get('/GetRegionRequestByCountryCode/' + cityCode)
                .then(response => {
                  if (
                    response.data.length == 0 ||
                    (response.data.length == 1 && !response.data[0])
                  ) {
                    setRegionData2([]);
                    axios
                      .get('/GetCityRequestByCountryCode/' + cityCode)
                      .then(response2 => {
                        if (
                          response2.data.length == 0 ||
                          (response2.data.length == 1 && !response2.data[0])
                        ) {
                          setCityData2([]);
                        } else {
                          setCityData2(response2.data);
                        }
                        setLoading2(false);
                      })
                      .catch(error => {
                        setLoading2(false);
                      });
                  } else {
                    setCityData2([]);
                    setRegionData2(response.data);
                  }
                  setLoading2(false);
                })
                .catch(error => {
                  setLoading2(false);
                });
          }
      
          const GetDistrictData = cityName => {
              setLoading2(true);
              axios
                .get('/GetDistrictRequest/' + cityName)
                .then(response => {
                  setDistrictData2(response.data);
                })
                .catch(error => {
                  setLoading2(false);
                });
          };
          
          const GetCityRequest = () => {
              setLoading2(true);
              axios
                .get('/GetCityRequest/')
                .then(response => {
                  setCityData2(response.data);
                  setLoading2(false);
                })
                .catch(error => {
                  setLoading2(false);
                });
          };
  
          const ChangeDistrict = (event,newInputValue) => {
            setDistrictData(newInputValue);
            
            if (DistrictData2.includes(newInputValue)  ) {
              setDistrictFiltered(true);
            }
            else{
              setDistrictFiltered(false );
              GetCityRequest();
            }
           
          };
  
          const GetAddressTypes = () => {
              axios
                .get(`/GetAddressTypes`)
                .then(response => {
                  if (response.data.length > 0) {
                    setAddressTypes(response.data);
                  }
                })
                .catch(error => { });
            };
  
            const SetCountry = (code) => {
              setSelected(code);
              setCountryData(code);
            }
  
          useEffect(() => {
              GetAddressTypes();
              GetRegionRequest();
          }, [locale]);
  
          return (
              <Grid item xs={12} sm={12} lg={12}>
                  <Card className={classes.cards}>
                      <CardContent className={classes.cardscontent}>
                          <Grid container spacing={2}>
                              <Grid item xs={12} sm={6} lg={6}>
                              <ReactFlagsSelect
                                  disabled
                                  size="small"
                                  selected={
                                    consumerAddressData.Country
                                      ? (consumerAddressData.Country === '' ? selected : consumerAddressData.Country)
                                      : selected
                                  }
                                  searchable
                                  id="Country"
                                  name="Country"
                                  onChange={e => setCountryData(e.target.value)}
                                  onSelect={code => SetCountry(code)}
                              />
                              </Grid>
                              <Grid item xs={12} sm={6} lg={6}>
                              <TextField
                                  disabled
                                  size="small"
                                  fullWidth
                                  select
                                  autoComplete="no"
                                  id="AddressTypeId"
                                  label={t('lblAddressType')}
                                  value={consumerAddressData.AddressTypeId ? consumerAddressData.AddressTypeId : consumerAddressData.ConsumerAddressTypeId}
                                  onChange={e => setAddressTypeIdData(e.target.value)}
                                  variant="outlined"
                              >
                                  {AddressTypes.map(p => {
                                  return (
                                      <MenuItem key={p.Id} value={p.Id}>
                                      {p.Dsc}
                                      </MenuItem>
                                  );
                                  })}
                              </TextField>
                              </Grid>
                              <Grid item xs={12} sm={12} lg={12}>
                                <TextField
                                      disabled
                                      size="small"
                                      id="Name"
                                      autoComplete="no"
                                      onChange={e =>setNameData(e.target.value)}
                                      value={consumerAddressData?.Name ? consumerAddressData.Name : serviceAddressData?.Name}
                                      fullWidth
                                      InputLabelProps={{ shrink: true }}
                                      label={t('lblName')}
                                      variant="outlined"
                                  />
                              </Grid>
                              <Grid item xs={12} sm={6} lg={6}>
                                <TextField
                                      disabled
                                      size="small"
                                      id="Email"
                                      autoComplete="no"
                                      onChange={e =>setEmailData(e.target.value)}
                                      value={consumerAddressData?.Email ? consumerAddressData.Email : serviceAddressData?.Email}
                                      fullWidth
                                      InputLabelProps={{ shrink: true }}
                                      label={t('lblEmail')}
                                      variant="outlined"
                                  />
                              </Grid>
                              <Grid item xs={12} sm={6} lg={6}>
                                <TextField
                                      disabled
                                      size="small"
                                      id="Phone"
                                      autoComplete="no"
                                      onChange={e =>setPhoneData(e.target.value)}
                                      value={consumerAddressData?.Phone ? consumerAddressData.Phone : serviceAddressData?.Phone}
                                      fullWidth
                                      InputLabelProps={{ shrink: true }}
                                      label={t('lblPhone')}
                                      variant="outlined"
                                  />
                              </Grid>
                              <Grid item xs={12} sm={6} lg={6}>
                              <TextField
                                  disabled
                                  size="small"
                                  id="State"
                                  style={{ display: StateScreen ? '' : 'none' }}
                                  autoComplete="no"
                                  value={consumerAddressData.State}
                                  onChange={e =>setStateData(e.target.value)}
                                  fullWidth
                                  label={t('lblState')}
                                  variant="outlined"
                              />
                              </Grid>
                              {SessionUser.TenantId != 71 ?
                              <Grid item xs={12} sm={6} lg={6}>
                              <Autocomplete
                                  disabled
                                  size="small"
                                  fullWidth
                                  freeSolo
                                  autoSelect
                                  style={{ display: RegionScreen ? '' : 'none' }}
                                  value={consumerAddressData.Region}
                                  options={RegionData2}
                                  onChange={(event,newValue) => {
                                    GetCity(event,newValue);
                                  }}
                                  renderInput={params => (
                                  <TextField
                                      {...params}
                                      label={t('lblRegion')}
                                      variant="outlined"
                                  />
                                  )}
                              />
                              </Grid> : null}
  
                              <Grid item xs={12} sm={6} lg={6}>
                              <Autocomplete
                                  disabled
                                  size="small"
                                  fullWidth
                                  freeSolo
                                  autoSelect
                                  value={consumerAddressData.City}
                                  options={CityData2}
                                  onChange={(event, newValue) => {
                                  GetDistrictRequest(event, newValue);
                                  }}
                                  renderInput={params => (
                                  <TextField
                                      {...params}
                                      label={t('lblCity')}
                                      variant="outlined"
                                  />
                                  )}
                              />
                              </Grid>
                              {SessionUser.TenantId != 71 ? 
                              <Grid item xs={12} sm={6} lg={6}>
                              <Autocomplete
                                  disabled
                                  size="small"
                                  fullWidth
                                  freeSolo
                                  autoSelect
                                  value={consumerAddressData.District}
                                  id="controllable-states-distict"
                                  options={DistrictData2}
                                  getOptionLabel={option => option}
                                  onChange={(event, newInputValue) => {
                                    ChangeDistrict(event, newInputValue);
                                  }}
                                  renderInput={params => (
                                  <TextField
                                      {...params}
                                      label={t('lblDistrict')}
                                      variant="outlined"
                                  />
                                  )}
                              />
                              </Grid> : null}
                              {SessionUser.TenantId != 71 ?
                              <Grid item xs={12} sm={6} lg={6}>
                                <TextField
                                    disabled
                                    size="small"
                                    id="Neighborhood"
                                    autoComplete="no"
                                    onChange={e =>setNeighborhoodData(e.target.value)}
                                    value={consumerAddressData.Neighborhood}
                                    fullWidth
                                    label={t('lblNeighborhood')}
                                    variant="outlined"
                                />
                              </Grid> : null}
  
                              <Grid item xs={12} sm={6} lg={6}>
                                <TextField
                                    disabled
                                    size="small"
                                    id="Street"
                                    autoComplete="no"
                                    onChange={e =>setStreetData(e.target.value)}
                                    value={consumerAddressData.Street}
                                    fullWidth
                                    label={t('lblStreet')}
                                    variant="outlined"
                                />
                              </Grid>
                              {SessionUser.TenantId != 71 ?
                              <Grid item xs={12} sm={6} lg={4}>
                              <TextField
                                  disabled
                                  size="small"
                                  id="Apartment"
                                  style={{ display: ApartmentScreen ? '' : 'none' }}
                                  autoComplete="no"
                                  onChange={e =>setApartmentData(e.target.value)}
                                  value={consumerAddressData.Apartment}
                                  fullWidth
                                  label={t('lblApartment')}
                                  variant="outlined"
                              />
                              </Grid> : null}
                              <Grid item xs={12} sm={6} lg={4}>
                                <TextField
                                    disabled
                                    size="small"
                                    id="DoorNr"
                                    style={{ display: DoorNrScreen ? '' : 'none' }}
                                    autoComplete="no"
                                    onChange={e =>setDoorNrData(e.target.value)}
                                    value={consumerAddressData.DoorNr}
                                    fullWidth
                                    label={t('lblDoorNr')}
                                    variant="outlined"
                                />
                                </Grid>
                              <Grid item xs={12} sm={6} lg={4}>
                                <TextField
                                    disabled
                                    size="small"
                                    id="PostCode"
                                    style={{ display: PostCodeScreen ? '' : 'none' }}
                                    autoComplete="no"
                                    onChange={e =>setPostCodeData(e.target.value)}
                                    value={consumerAddressData.PostCode}
                                    fullWidth
                                    label={t('lblPostCode')}
                                    variant="outlined"
                                  />
                              </Grid>
                              <Grid item xs={12} sm={6} lg={12}>
                              <TextField
                                  disabled
                                  size="small"
                                  multiline
                                  rows={5}
                                  fullWidth
                                  id="AddressItem"
                                  autoComplete="no"
                                  onChange={e => setAddressItemData(e.target.value)}
                                  value={consumerAddressData.AddressItem ? consumerAddressData.AddressItem : consumerAddressData.Address}
                                  label={t('lblAddress')}
                                  variant="outlined"
                              />
                              </Grid>
                          </Grid>
                      </CardContent>
                  </Card>
              </Grid>
          )
      }
  
  export default ConsumerAddress;